module.exports = "/images/Submit_2of5.jpg";